export enum CharacterType {
  ALPHA = 'ALPHA',
  NUMERICAL = 'NUMERICAL',
  ALPHANUMERIC = 'ALPHANUMERIC',
}
